#ifdef USE_NUMBERS
    vec4 numColor = stampNumbers(vNormalW, numbersMode);
    if (numColor.a > 0.1) {
        // Remove lighting reflections from the numbers
        totalSpecular.rgb = vec3(0.0);

        // Replace diffuse color by number color based on its alpha to blend
        // This gives the numbers the darkened edges for better legibility
        totalDiffuse.rgb = numColor.rgb * numColor.a;
    }
#endif
